module.exports = __webpack_public_path__ + "static/2-95590af56c39978f711f63d95b661124.jpg";